export interface FormaPagamentoModel {
    name: string;
    descricao: string;
}

export const formasPagamento: FormaPagamentoModel[] = [
    { name: 'CARTAO_CREDITO', descricao: 'Cartão de Crédito' },
    { name: 'CARTAO_DEBITO', descricao: 'Cartão de Débito' },
    { name: 'TRANSFERENCIA', descricao: 'Transferência' }
];